<div mat-dialog-title class="matDialogTitle">
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
    </div>
    <span>{{ title }}</span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<div mat-dialog-content class="matDialogContent">
    <div class="content-body control-content-body" [ngClass]="{content_body_en:lang==2}"
        style='overflow-x:auto;direction:rtl;'>
        <mat-table [dataSource]="dataSource" style='min-width:100%'
            class='table-scroll mat_table_fa_without_scroll_bg pe1'
            [ngClass]="{mat_table_en_without_scroll:lang==2,en1:lang == 2}"
            [ngStyle]="{'direction': lang == 2 ? 'ltr' : 'rtl' }">
            <ng-container matColumnDef="row">
                <mat-header-cell *matHeaderCellDef style='max-width:40px'>
                    <span *ngIf="lang == 1">ردیف</span>
                    <span *ngIf="lang == 2">#</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style='max-width:40px'>{{ i + 1 }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="type">
                <mat-header-cell *matHeaderCellDef style="max-width:100px">
                    <span *ngIf="lang == 1">نوع درخواست</span>
                    <span *ngIf="lang == 2">Material Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:100px">{{
                    x.wharehouse_invoice_type_title }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef>
                    <span *ngIf="lang == 1">نام کالا</span>
                    <span *ngIf="lang == 2">Material Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index">{{
                    x.wharehouse_material_title }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="number">
                <mat-header-cell *matHeaderCellDef style="max-width:100px">
                    <span *ngIf="lang == 1"> میزان درخواست</span>
                    <span *ngIf="lang == 2">---</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:100px">{{
                    x.wharehouse_order_number | number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="price">
                <mat-header-cell *matHeaderCellDef style="max-width:100px">
                    <span *ngIf="lang == 1">قیمت واحد</span>
                    <span *ngIf="lang == 2">Material Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:100px">{{
                    x.wharehouse_order_price | number }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="currency">
                <mat-header-cell *matHeaderCellDef style="max-width:100px">
                    <span *ngIf="lang == 1">واحد شمارش</span>
                    <span *ngIf="lang == 2">Material Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:100px">{{
                    x.site_currency_title }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef style="max-width:100px">
                    <span *ngIf="lang == 1"> شناسه </span>
                    <span *ngIf="lang == 2">Id</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:100px">{{
                    x.wharehouse_order_id }}</mat-cell>
            </ng-container>

            <mat-header-row class="mat-header-row-dialog" *matHeaderRowDef="displayedColumns" color="primary">
            </mat-header-row>
            <mat-row class="mat-header-row-dialog" *matRowDef="let row;columns:displayedColumns;let i = index"
                (click)="mat_table_selectedRow = row" (mouseenter)="mat_table_hoverRow = row"
                [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
                class="cursor"></mat-row>

        </mat-table>
    </div>
</div>